"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = void 0;
exports.palette = {
    // Main colors
    primary: '#ff9f1c',
    secondary: '#ff4040',
    tertiary: '#2ec4b6',
    // Monochrome
    white: '#fff',
    lightGrey: '#7a8c99',
    midGrey: '#353f4c',
    grey: '#1b2329',
    dark: '#0a1014'
};
//# sourceMappingURL=palette.js.map